import { GeoJSON } from 'react-leaflet';

export default function RegionsLayer({ data, highlighted }) {

  return (
    <GeoJSON
      data={data}
      style={(feat) => {
        const active = feat?.properties && feat.properties.region === highlighted;
        return {
          color: active ? '#016bdd' : '#2a2a2a',
          weight: active ? 1.8 : 0.2,
          fillOpacity: active ? 0.1 : 0,
        };
      }}
    />
  );
}
